import React, { useState } from 'react';
import { Button, Row } from 'reactstrap';
import Rating from 'react-rating';
import { Translate } from 'react-localize-redux';

import PropTypes from 'prop-types';
import RatingIcon from './RatingIcon';


function RecentReview(props) {
  const [isOpen, setIsOpen] = useState(true);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div style={{ 'padding-right': '15px', 'padding-left': '15px' }}>
      <Row>
        <Rating
          initialRating={props.rating}
          emptySymbol={<RatingIcon size="20px" />}
          fullSymbol={<RatingIcon full size="20px" />}
          readonly
        />
      </Row>
      <Row>
        <p
          className={isOpen ? 'sm-text collapseReview' : 'sm-text'}
          style={{ marginBottom: '-12px' }}
        >
          {props.review}
        </p>
        <Button color="link" onClick={toggle}>
          {isOpen
            ? <Translate id="seeMore" />
            : <Translate id="seeLess" />}
        </Button>
      </Row>
      <Row className="justify-content-end" style={{ paddingTop: "10px" }}>
        <b>{props.date}</b>
      </Row>
    </div>
  );
}

RecentReview.propTypes = {
  date: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  review: PropTypes.string.isRequired,
};

export default RecentReview;
